<template>
  <section
    :class="[
      'ugc-controls-wrapper',
      {
        'ugc-controls-wrapper--overflow': areInstructionsVisible || isHistoryVisible,
      }
    ]"
  >
    <section v-if="areInstructionsVisible" class="ugc-controls-wrapper-content control">
      <div
        :class="[
          'ugc-controls-wrapper-content-img',
          {
            hide: hideReferenceImg,
            'ugc-controls-wrapper-content-img--second': returnPlacementViewOrder === 1,
          }
        ]"
      >
        <img :src="setInstructionsImg" />
      </div>
      <div
        :class="[
          'ugc-controls-wrapper-content-instructions',
          {
            'ugc-controls-wrapper-content-instructions--second': returnPlacementViewOrder === 1,
          }
        ]"
      >
        {{ isDesignTransferApplied ? transferDesignPlacement: setInstructionsText }}
      </div>
    </section>
    <ugc-tools-history v-show="isHistoryVisible"></ugc-tools-history>
    <component class="control" :is="activeControl"></component>
    <ugc-tools-confirmation-controls v-show="showConfirmationControls"></ugc-tools-confirmation-controls>
  </section>
</template>

<script>
import ugcToolsConfirmationControls from '@/components/UGC/Tools/ConfirmationControls';
import ugcToolsHistory from '@/components/UGC/Tools/History';
import ugcBackgroundColorControl from "@/components/UGC/Tools/BackgroundColorControl";
import ugcCropperControl from "@/components/UGC/Tools/CropperControl";
import ugcFlipImageControl from "@/components/UGC/Tools/FlipImageControl";
import ugcReplaceImageControl from "@/components/UGC/Tools/ReplaceImageControl";
import ugcRotateImageControl from "@/components/UGC/Tools/RotateImageControl";
import ugcTintImageControl from "@/components/UGC/Tools/TintImageControl";
import ugcZoomControl from "@/components/UGC/Tools/ZoomControl";
import ugcCropBox from "@/components/UGC/Tools/CropBox";
import ugcTileControl from "@/components/UGC/Tools/TileControl";
import ugcPopArtControl from "@/components/UGC/Tools/PopArtControl";

export default {
  name: "UgcToolsControlsWrapper",
  components: {
    ugcToolsConfirmationControls,
    ugcToolsHistory,
    ugcBackgroundColorControl,
    ugcCropperControl,
    ugcFlipImageControl,
    ugcReplaceImageControl,
    ugcRotateImageControl,
    ugcTintImageControl,
    ugcZoomControl,
    ugcCropBox,
    ugcTileControl,
    ugcPopArtControl
  },
  props: {
    activeControl: {
      type: String,
      default: null
    },
    showDefaultControl: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      showIntructions: true
    };
  },
  computed: {
    isDesignTransferApplied() {
      return this.$store.state.utils.isDesignTransferApplied;
    },
    areInstructionsVisible() {
      if (
        (!this.activeControl || !this.showDefaultControl) &&
        this.showIntructions
      ) {
        return true;
      } else {
        return false;
      }
    },
    isHistoryVisible() {
      if (
        (!this.activeControl || !this.showDefaultControl) &&
        !this.showIntructions &&
        this.returnPlacementViewOrder === 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    pdm() {
      return this.$store.state.utils.pdm;
    },
    componentName() {
      return this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].activeUGCComponent;
    },
    returnPlacementViewOrder() {
      return this.$store.getters["ugc/tempData/getPlacementViewOrder"];
    },
    hideReferenceImg() {
      if (this.pdm.sku === "backpack") {
        return true;
      } else {
        return false;
      }
    },
    showConfirmationControls() {
      return (
        this.activeControl !== "" &&
        this.activeControl !== "ugc-replace-image-control"
      );
    },
    setInstructionsText() {
      return this.$store.state.translations.data[`ugcPlacement${(this.returnPlacementViewOrder + 1)}RefInstructions-${this.componentName}`];
    },
    transferDesignPlacement() {
      return this.$store.state.translations.data.transferDesignPlacement
    },
    setInstructionsImg() {
      return (
        this.$store.state.endPoints.customizer.s3ModelsBucket +
        this.pdm.components[this.componentName].ugc.placements[
          this.returnPlacementViewOrder
        ].reference_image_url
      );
    },
    stepsPreviouslyApplied() {
      const { steps } = this.$store.state.ugc.stateManager;

      return steps && !!steps.filter(step => !!step.control).length;
    }
  },
  watch: {
    returnPlacementViewOrder(val) {
      this.hideInstructions(val === 0 ? !this.stepsPreviouslyApplied : true);
    }
  },
  methods: {
    hideInstructions(hide) {
      this.showIntructions = hide;
    }
  },
  created() {
    this.$eventBus.$on("hide-ugc-intructions", this.hideInstructions);
  },
  mounted() {
    this.hideInstructions(this.returnPlacementViewOrder === 0 ? !this.stepsPreviouslyApplied : true);
  },
  beforeDestroy() {
    this.$eventBus.$off("hide-ugc-intructions", this.hideInstructions);
  }
};
</script>
